var amdi18n={"__root":{"n1_of_n2_items":"%{n1} of %{n2} items"},"__cs":{"n1_of_n2_items":"%{n1} z %{n2} položek"},"__da":{"n1_of_n2_items":"%{n1} af %{n2} elementer"},"__de":{"n1_of_n2_items":"%{n1} von %{n2} Elementen"},"__es":{"n1_of_n2_items":"%{n1} de %{n2} elementos"},"__fi":{"n1_of_n2_items":"%{n1} / %{n2} kohdetta"},"__fr":{"n1_of_n2_items":"%{n1} sur %{n2} éléments"},"__hr":{"n1_of_n2_items":"%{n1} od %{n2} stavki"},"__hu":{"n1_of_n2_items":"%{n1} / %{n2} elem"},"__it":{"n1_of_n2_items":"%{n1} di %{n2} elementi"},"__ja":{"n1_of_n2_items":"%{n2} 個のアイテム中 %{n1} 個"},"__kk":{"n1_of_n2_items":"%{n2} элементтің %{n1}"},"__ko":{"n1_of_n2_items":"%{n2}개 중 %{n1}개의 항목"},"__nb":{"n1_of_n2_items":"%{n1} av %{n2} elementer"},"__nl":{"n1_of_n2_items":"%{n1} van %{n2} items"},"__pl":{"n1_of_n2_items":"%{n1} z %{n2} elementów"},"__pt-br":{"n1_of_n2_items":"%{n1} de %{n2} itens"},"__ro":{"n1_of_n2_items":"%{n1} din %{n2} articole"},"__ru":{"n1_of_n2_items":"%{n1} из %{n2} элементов"},"__sl":{"n1_of_n2_items":"%{n1} od %{n2} postavk"},"__sv":{"n1_of_n2_items":"%{n1} av %{n2} objekt"},"__th":{"n1_of_n2_items":"%{n1} จาก %{n2} รายการ"},"__tr":{"n1_of_n2_items":"%{n1} / %{n2} öğe"},"__zh":{"n1_of_n2_items":"第 %{n1} 项（共 %{n2} 项）"},"__zh-cn":{"n1_of_n2_items":"第 %{n1} 项（共 %{n2} 项）"},"__zh-tw":{"n1_of_n2_items":"%{n1} / %{n2} 個項目"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/js/lib/@waca/vis-crosshairs/src/js/nls/VisCrosshairsResources.js
// module id = 480
// module chunks = 1